<!-- 创建地块 -->
<template>
  <div class="create-parcels-page">
    <div class="top-nav" :style="{ 'padding-top':'24px', background: 'white' }">
      <van-nav-bar title="创建地块" left-arrow @click-left="onClickLeft"></van-nav-bar>
      <p class="text">
        <span>面积： {{ formData.plotArea || '0.00' }}亩</span>
      </p>
      <p class="tips">操作提示：拖动圆点调整地块边界</p>
    </div>
    <div class="btn-card text-right" v-if="!isDraw">
      <div class="btn-item">
        <van-button type="primary" @click="confirmArea">确认</van-button>
      </div>
    </div>
    <div id="container"></div>
    <van-popup v-model="showPopup" round position="bottom" custom-style="height: 30%">
      <!-- 可以使用 CellGroup 作为容器 -->
      <van-cell-group inset>
        <!-- <van-field
          v-model="formData.parcelName"
          label="地块名称"
          placeholder="请输入地块名称"
        /> -->
        <van-field v-model="formData.plotArea" label="地块面积" type="number" placeholder="请输入地块面积">
          <template #button>
            <span>亩</span>
            <!-- <van-button size="small" type="primary">亩</van-button> -->
          </template>
        </van-field>
        <div class="operation-button flex">
          <div class="div text-left">
            <van-button type="default" @click="cancelBtn">取消</van-button>
          </div>
        </div>
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import coordtransform from "coordtransform";
import { NavBar, Popup, Field, CellGroup, Button, Toast } from "vant";
import { transformFromGCJToWGS } from '@/utils/transformation'
// import getUserMethods from "utils/getUserMethods";
import { mapState } from "vuex";
export default {
  // mixins: [getUserMethods], // mixins混入策略
  data() {
    return {
      windowHeight: document.documentElement.clientHeight, // 实时屏幕高度
      // api_farmField_update: "/farmField/update", // 田地编辑
      map: null,
      lon: '104.170981', // 定位后获取默认当前城市
      lat: '30.800835',
      polyEditor: null,
      isDraw: true, // 初始化默认可画图
      drawType: "", // 描点：addnode，拖动：adjust
      showPopup: false,
      formData: {
        // parcelName: "地块名称",
        plotArea: 0,
        myPath: [], //经纬度数组
      },
      // distance: '', // 周长
      items: [],
      isCreateParcels: false,
    };
  },
  components: {
    "van-nav-bar": NavBar,
    'van-popup': Popup,
    'van-cell-group': CellGroup,
    'van-field': Field,
    'van-button': Button,
  },
  computed: {
    ...mapState({
      location: (state) => state.user.location,
    }),
  },
  watch: {
    location: {
      handler(newVal) {
        //DOM初始化完成进行地图初始化
        this.lon = newVal.lon;
        this.lat = newVal.lat;
        let plots = [[104.161718,30.807931],[104.162132,30.808419],[104.163121,30.808072]];
        if (plots && plots.length > 0) {
          plots.forEach(item => {
            console.log(item,858)
            this.items.push(item);
          });
        }
        this.initMap();
      },
      deep: true,
      immediate: true
    },
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    //在created或monted生命周期中将FastClick绑定到body
    this.$fastClick.attach(document.body);
    // 浏览器高度
    document.getElementById("container").style.height = this.windowHeight - 106 + "px";
  },
  methods: {
    /**
     * 返回上级田地新增
     */
    onClickLeft() {
      this.$store.commit("farmPlotInfo", null); // 所选地块经纬度集合存储
      this.$store.commit("farmPlotArea", null); // 所选地块面积
      this.$router.replace({name:'创建地块'});
      this.$router.go(-1);
    },
    /**
     * 地图初始化
     */
    initMap() {
      AMapLoader.load({
        key: "30f8b93a988c168e4e44e5e674dc49b1", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Scale", "AMap.PolygonEditor"], // 需要使用的的插件列表，如比例尺'AMap.Scale',AMap.PolygonEditor多边形编辑器等
      })
        .then((AMap) => {
          //天地图Key和高德地图Key自己申请就好
          //高德矢量
          var layer_std = new AMap.TileLayer();
          //高德路网
          var layer_dl = new AMap.TileLayer.RoadNet();
          // 天地图影像
          var imgLayer = new AMap.TileLayer({
            zIndex: 0,
            getTileUrl: function (x, y, z) { // company: 29de3ed451c572bc898b208ee7c06880 mine:18cd4915cba253ee17947e0596e28b91
              return (
                "http://t0.tianditu.gov.cn/DataServer?T=img_w&tk=" +
                "29de3ed451c572bc898b208ee7c06880" +
                "&x=" +
                x +
                "&y=" +
                y +
                "&l=" +
                z
              );
            },
          });
          let lon = this.items.length > 0 ? this.items[0][0] : this.lon
          let lat = this.items.length > 0 ? this.items[0][1] : this.lat
          this.map = new AMap.Map("container", {
            // 设置地图容器id
            // viewMode: "3D", // 是否为3D地图模式
            resizeEnable: true,
            zoom: 17, // 初始化地图级别
            zooms: [3, 20],
            expandZoomRange: true, // 扩大高德地图缩放级别到20
            layers: [layer_std, imgLayer, layer_dl],
            center: transformFromGCJToWGS(lon, lat), // 初始化地图中心点位置
            // center: coordtransform.gcj02towgs84(lon, lat),
          });
          // 比例尺
          AMap.plugin("AMap.Scale", () => {
            var scale = new AMap.Scale({
              visible: true,
            });
            this.map.addControl(scale);
          });

          // 自定义瓦片加载
          var tilerLayer = new AMap.TileLayer({
            zIndex: 5,
            zooms: [17, 20],
            getTileUrl: function (x, y, z) {
              return "/imgs/" + z + "/" + x + "x" + y + ".png";
            },
          });
          tilerLayer.setMap(this.map);
          layer_std.hide(); // 高德矢量隐藏
          imgLayer.hide(); // 影像地图隐藏
          imgLayer.show(); // 影像地图开启
          this.map.setFitView(); // 缩放地图到合适的视野级别
          this.polyEditor = new AMap.PolygonEditor(this.map);
          // console.log(this.polyEditor,'多边形编辑器-polyEditor');
          this.createPolygon(); // 绘制多边形
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 绘制多边形
    createPolygon() {
      this.polyEditor.open(); // 覆盖物编辑
      // 多边形监听坐标点的变化
      this.polyEditor.on('addnode', (event) => {
        this.drawType = 'addnode';
        let getPath = event.target.getPath();
        let myPath = [];
        getPath.forEach(item => {
          let arry = [];
          arry.push(item.lng);
          arry.push(item.lat);
          myPath.push(arry);
        });
        console.log(myPath,8088)
        console.log(myPath, 'myPath-描点');
        console.log(myPath.length, 'myPath点数');
        // 计算区域面积
        var myPolygon = new AMap.Polygon({
          path: myPath,
        });
        this.formData.plotArea = (myPolygon.getArea() / 666.67).toFixed(2);
        this.formData.myPath = myPath;
        // 点标记显示内容，HTML要素字符串
        var amapMarker = document.getElementsByClassName('amap-marker');
        var markerContent = `<div ref="plotArea" style="width: 45px;height: 15px;color: white;">${this.formData.plotArea}亩</div>`;
        var position = new AMap.LngLat(this.calculateCenter(myPath).lng, this.calculateCenter(myPath).lat);
        var marker = new AMap.Marker({
          position: position,
          // 将 html 传给 content
          content: markerContent,
          // 以 icon 的 [center bottom] 为原点
          offset: new AMap.Pixel(0, 0)
        });
        // 将 markers 添加到地图
        this.map.add(marker);
        if (amapMarker.length > 1) {
          amapMarker[0].remove(); // 使用remove()方法删除dom节点本身
        }
      });
      //监听拖动变化
      this.polyEditor.on("adjust", (event) => {
        this.drawType = 'adjust';
        let getPath = event.target.getPath();
        let myPath = [];
        getPath.forEach(item => {
          let arry = [];
          arry.push(item.lng);
          arry.push(item.lat);
          myPath.push(arry);
        });
        // 计算区域面积
        var myPolygon = new AMap.Polygon({
          path: myPath,
        });
        this.formData.plotArea = (myPolygon.getArea() / 666.67).toFixed(2);
        this.formData.myPath = myPath;
        // this.distance = Math.round(AMap.GeometryUtil.distanceOfLine(getPath));

        // 点标记显示内容，HTML要素字符串
        var amapMarker = document.getElementsByClassName('amap-marker');
        var markerContent = `<div ref="plotArea" style="width: 45px;height: 15px;color: white;">${this.formData.plotArea}亩</div>`;
        var position = new AMap.LngLat(this.calculateCenter(myPath).lng, this.calculateCenter(myPath).lat);
        var marker = new AMap.Marker({
          position: position,
          // 将 html 传给 content
          content: markerContent,
          // 以 icon 的 [center bottom] 为原点
          offset: new AMap.Pixel(0, 0)
        });
        // 将 markers 添加到地图
        this.map.add(marker);
        if (amapMarker.length > 1) {
          amapMarker[0].remove(); // 使用remove()方法删除dom节点本身
        }
      });

      this.polyEditor.on("add", (data) => {
        console.log(data, 'data-add');
        console.log(data.lnglat,'lnglat'); // 地块描点最后的经纬度
        let locationData = {
          lng: data.lnglat.lng,
          lat: data.lnglat.lat
        };
        var polygon = data.target;
        this.polyEditor = new AMap.PolygonEditor(this.map, polygon, {
          editOptions: {
            strokeColor: "#F77A3C", //线颜色
            strokeWeight: 3, //线宽
            strokeStyle: 'solid', // 轮廓线样式，实线:solid，虚线:dashed 
            fillColor: "#F77A3C", //填充色
            fillOpacity: 0.4, //填充透明度
          }
        }); // 多边形编辑器指定编辑的多边形
        // 绘制地块完成展示确认按钮
        this.isDraw = false;
      });
    },
    /**
     * 获取 高德地图 多边形区域的中心
     */
    calculateCenter(lnglatarr) {
      var total = lnglatarr.length;
      var X = 0,
        Y = 0,
        Z = 0;
      lnglatarr.map((item) => {
        var lng = (item[0] * Math.PI) / 180;
        var lat = (item[1] * Math.PI) / 180;
        var x, y, z;
        x = Math.cos(lat) * Math.cos(lng);
        y = Math.cos(lat) * Math.sin(lng);
        z = Math.sin(lat);
        X += x;
        Y += y;
        Z += z;
      });
      X = X / total;
      Y = Y / total;
      Z = Z / total;
      var Lng = Math.atan2(Y, X);
      var Hyp = Math.sqrt(X * X + Y * Y);
      var Lat = Math.atan2(Z, Hyp);
      return new AMap.LngLat((Lng * 180) / Math.PI, (Lat * 180) / Math.PI);
    },
    /**
     * 地块确认按钮，调起弹框
     */
    confirmArea() {
      // 地块绘制完调起弹框展示确认
      this.showPopup = true;
    },
    /**
     * 取消圈地
     */
    cancelBtn() {
      this.showPopup = false;
    },
  },
};
</script>
<style lang='scss' scoped>
/* @import url(); 引入css类 */
.create-parcels-page {
  #container {
    width: 100%;
    padding: 0px;
    // 地图刚在在nav下展示
    margin: 0px;
  }
  .top-nav{
    .text {
      width: 100%;
      height: 30px;
      line-height: 32px;
      text-align: center;
      color: #fff;
      background: #000000b3;
    }
    .tips {
      width: 100%;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: rgb(255, 230, 0);
    }
  }
  .btn-card {
    width: 100%;
    height: 60px;
    position: fixed;
    z-index: 2;
    bottom: 0;

    .btn-item {
      display: inline-block;
      margin-right: 15px;
    }
  }
}
</style>
<style lang='scss'>
/* 组件全局css类调整 */
.create-parcels-page {
  .van-nav-bar {
    .van-nav-bar__title {
      color: #262833;
      font-size: 16px;
      font-weight: bold;
    }

    .van-icon,
    .van-nav-bar__text {
      color: #262833;
      font-size: 16px;
      font-weight: bold;
    }
  }
  .btn-card {
    .btn-item {
      .van-button {
        height: 40px;
        background: linear-gradient(90deg, #FF8B57, #FF6B4F);
        box-shadow: 0px 4px 10px 0px rgba(247, 122, 60, 0.2);
        border: 0.02667rem solid #F77A3C;
      }
    }
  }
  .van-popup {
    .van-cell-group {
      .van-cell {
        .van-cell__value {
          .van-field__body {
            .van-field__control {
              text-align: right;
            }
          }
        }
      }
    }
    .operation-button {
      padding: 10px 18px;
      .div {
        flex: 0.5;

        .van-button {
          width: 120px;
          height: 40px;
        }
      }
      .text-right {
        .van-button {
          background: linear-gradient(90deg, #FF8B57, #FF6B4F);
          box-shadow: 0px 4px 10px 0px rgba(247, 122, 60, 0.2);
          border: 0.02667rem solid #F77A3C;
        }
      }
    }
  }
}
</style>